export class State {
    name?: string;
    customName?: string;
    reason?: string;
    stateId: number;
    isRead?: boolean;
    opportunityId?: number;
}



